const axios = require("axios");


const axiosInstance = axios.default.create({
  baseURL: 'https://cursos.novaescola.org.br',
  // baseURL: 'http://localhost:4001',
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
});

const ContentServiceApi = {
 
  getCurrentAlert: async () => {
    const url = "/api/alert/current";
    const { data } = await axiosInstance.get(url);
    return data;
  }
}
export default ContentServiceApi;
